import { InspectionItem, ReportLanguage } from '../types';

// Nur 'open' zählt als Mangel: 'info' (Hinweis), 'closed' (erledigt),
// 'good' und 'general' gelten als positiv bzw. neutral.
export const hasOpenDefects = (items?: Pick<InspectionItem, 'status'>[]): boolean =>
    (items ?? []).some(i => i.status === 'open');

const BODY_INTRO_DE = "Sehr geehrte Damen und Herren,\n\nanbei erhalten Sie das Begehungsprotokoll Nr. {nr} zur Baustellenbegehung vom {datum}.\nProjekt: {projekt}\nOrt: {ort}\n\n";
const BODY_OUTRO_DE = "\n\nMit freundlichen Grüßen";
const BODY_INTRO_EN = "To whom it may concern,\n\nplease find attached the site inspection report No. {nr} from {datum}.\nProject: {projekt}\nLocation: {ort}\n\n";
const BODY_OUTRO_EN = "\n\nKind regards";

const DEFECT_NOTE = {
    de: "Bitte beachten Sie die aufgeführten Mängel und Fristen.",
    en: "Please note the listed defects and deadlines.",
};

const NO_DEFECT_NOTE = {
    de: "Zum Zeitpunkt der Begehung wurden keine nennenswerten sicherheitstechnischen Mängel festgestellt.",
    en: "At the time of the inspection, no significant safety defects were identified.",
};

export const getDefaultEmailBody = (lang: ReportLanguage, reportHasOpenDefects: boolean): string => {
    const note = reportHasOpenDefects ? DEFECT_NOTE : NO_DEFECT_NOTE;
    return lang === 'en'
        ? BODY_INTRO_EN + note.en + BODY_OUTRO_EN
        : BODY_INTRO_DE + note.de + BODY_OUTRO_DE;
};
